import Axios from 'axios';
import { PublicClientApplication } from '@azure/msal-browser';
import CryptoJS from 'crypto-js';

import { loginRequest, msalConfig } from '../../authConfig';
import { guid } from '../../Components/Common/Util';
import { Store } from '../Store';
import { SHAKEY } from '../../Components/constants/constants';

const msalInstance = new PublicClientApplication(msalConfig);
const SSH_VERSION = 'v1';

export async function getCommonHeaders(authTokenNeeded = true, apiObj = {}) {
    var authToken = {
        'Access-Control-Allow-Headers': 'Content-Type,Authorization,',
        'ssh-traceid': CryptoJS.AES.encrypt(guid(), SHAKEY),
        // 'ssh-tstamp': CryptoJS.AES.encrypt(new Date().getTime(), SHAKEY),
        'ssh-senderid': CryptoJS.AES.encrypt('sshuser', SHAKEY)
    };
    if (!authTokenNeeded) {
        return {
            // 'Access-Control-Allow-Headers': 'Content-Type',
            'ssh-traceid': CryptoJS.AES.encrypt(guid(), SHAKEY),
            'ssh-senderid': CryptoJS.AES.encrypt('sshuser', SHAKEY)
        };
    }
    if (msalInstance.getAllAccounts()?.length > 0) {
        var tokenRequest = {
            account: msalInstance.getAllAccounts()[0],
            scopes: loginRequest.scopes
        };
        await msalInstance
            .acquireTokenSilent(tokenRequest)
            .then(async (response) => {
                const cipherText = CryptoJS.AES.encrypt(response?.account?.username, SHAKEY);

                authToken = {
                    ...authToken,
                    authorization: 'Bearer ' + response.accessToken,
                    'ssh-uident': cipherText
                };
            })
            .catch((err) => {
                // could also check if err instance of InteractionRequiredAuthError if you can import the class.
                if (err.name === 'InteractionRequiredAuthError') {
                    return msalInstance
                        .acquireTokenPopup(tokenRequest)
                        .then(async (response) => {
                            const cipherText = CryptoJS.AES.encrypt(response?.account?.username, SHAKEY);
                            authToken = {
                                ...authToken,
                                authorization: 'Bearer ' + response.accessToken,
                                'ssh-uident': cipherText
                            };
                        })
                        .catch((catcherr) => {
                            // handle error
                        });
                }
            });
    }
    const store = Store.getState();
    if (store?.CommonStore?.impersonateUser?.azureAdID) {
        return {
            'Content-Type': apiObj?.fileUpload ? 'multipart/form-data' : 'application/json',
            ...authToken,
            ImpUserAzureId: store?.CommonStore?.impersonateUser?.azureAdID || null,
            'Cache-Control': 'max-age=0, no-cache, no-store',
            Pragma: 'no-cache',
            Expires: '0'
        };
    } else {
        return {
            'Content-Type': apiObj?.fileUpload ? 'multipart/form-data' : 'application/json',
            ...authToken,
            'Cache-Control': 'max-age=0, no-cache, no-store',
            Pragma: 'no-cache',
            Expires: '0'
        };
    }
}

export function getFullURL(url, pathsList = null, customEndPoint = '') {
    let apiEndPointURL = customEndPoint ? customEndPoint : process.env.REACT_APP_API_URL + '/' + SSH_VERSION;
    // In API BASE URL - DO NOT PUT '/' at the END
    let fullURL = apiEndPointURL + '/' + url;
    if (pathsList) {
        for (const path of pathsList) {
            fullURL = fullURL + '/' + path;
        }
    }
    return fullURL;
}

export async function makeAPICall(payload) {
    let { apiObj, cutomURL, requestObj, queryParams, pathsList, customHeaders, offline, queueNo } = payload;
    let headers = await getCommonHeaders(apiObj.authTokenNeeded, payload);
    if (customHeaders) {
        headers = { ...headers, ...customHeaders };
    }
    const fullURL = getFullURL(apiObj.customURLNeeded ? cutomURL : apiObj.url, pathsList, apiObj.customEndPoint);

    const response = await Axios.request({
        method: apiObj.method,
        url: fullURL,
        data: requestObj,
        params: queryParams,
        headers: headers,
        validateStatus: false
    });

    return { ...response.data, offline: offline, statusCode: response.status, queueNo: queueNo };
    // This will not happen bcz if invalid, it will throw error
}

export function checkInternetConnectivity() {
    return navigator.onLine;
}

// This constant is used for tests - spyOn and also for segregation of logic from sagas_old.js
const callAPIFunctions = {
    callAPI: makeAPICall,
    checkInternet: checkInternetConnectivity,
    headers: getCommonHeaders
};

export default callAPIFunctions;
